/**
 * @project E-School Web
 * @author Vothana CHY
 * @date 2026-07-15
 */

export const CONTACT_INFO = {
  phones: [
    { display: '015 372 363', value: '015372363' },
    { display: '085 372 363', value: '085372363' },
    { display: '060 372 363', value: '060372363' },
  ],
  email: 'info@e-schoolcambodia.com',
  googleMapsUrl: 'https://www.google.com/maps/search/?api=1&query=E-School+Cambodia',
  socials: {
    facebook: 'https://www.facebook.com/eschoolcambodia',
    youtube: 'https://www.youtube.com/channel/UCXAVs_YRUwsnx5I-Toy-7Dg',
    telegram: 'https://telegram.me/eschool_cambodia',
    linkedin: 'https://www.linkedin.com/in/eschoolcambodia/',
    messenger: 'https://m.me/eschoolcambodia',
  },
};
